module.exports = __webpack_public_path__ + "static/media/autochilango-street-selected.139523bf.svg";